import { render, staticRenderFns } from "./S12GamesModal.vue?vue&type=template&id=02f6719c&scoped=true"
import script from "./S12GamesModal.vue?vue&type=script&lang=js"
export * from "./S12GamesModal.vue?vue&type=script&lang=js"
import style0 from "./S12GamesModal.vue?vue&type=style&index=0&id=02f6719c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02f6719c",
  null
  
)

export default component.exports